import { useEffect, useRef } from "react";
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';

const CommentContent = ({message,user_name,currentTime, emoji}) => {
    const ref = useRef();
    useEffect(() => {
        ref.current?.scrollIntoView({behavior:"smooth"})
    },[message]);

    return ( 
        <div ref={ref} className="comment-content">
         
            <div className="message-body">
            <div className="timesent">
            {user_name && <p>{user_name}</p>} 
            <HistoryToggleOffIcon style={{backgroundColor:"white",borderRadius:"50%"}}/> 
            {currentTime && <span>{currentTime}</span>}
            </div>
                {message && <pre>{message}</pre>}
                {emoji && <img src={emoji} alt="emoticon was sent" title={`${user_name}'s reaction`} />}
            </div>

        </div>
     );
}
export default CommentContent;